import React from 'react';
import { SectionTitle } from '../elements';

export function PrivacySection() {
  return (
    <section className="section" style={{ minHeight: 'calc(100vh - 65px)' }}>
      <div className="container is-slim">
        <SectionTitle title="プライバシーポリシー" caption="PRIVACY POLICY" />
        <div className="content">
          <h4>個人情報の取扱について</h4>
          <p>
            エントリー時に記入していただいた個人情報について、不正アクセス、紛失、漏洩等が発生しないよう管理責任者を定め、個人情報取り扱い規定を整備し、これらの危険に対する安全対策を積極的に実施します。
          </p>
          <h4>個人情報の利用目的について</h4>
          <p>
            入力していただいた個人情報は株式会社エイジ・エンタテインメント（以下当社）にて厳重に管理し、次の目的以外では使用いたしません。
          </p>
          <ul>
            <li>FRESH CAMPUS CONTEST 2019の選考および告知</li>
            <li>オーディションおよび出演依頼に関する案内</li>
          </ul>
          <h4>第三者への提供について</h4>
          <p>
            入力していただいた個人情報は、法律に基づいた、警察等の行政機関や司法機関からの要請があった場合を除き、ご本人の同意がない限り第三者には提供いたしません。
          </p>
          <h4> 個人情報の委託について</h4>
          <p>
            個人情報の取り扱いの全てもしくはその一部を外部に委託する場合、委託を受けた者に対して適切な監督を実施します。
          </p>
          <h4>エントリー時の写真について</h4>
          <p>バストアップ写真・全身写真は、著作権上や使用許諾上問題の無い写真をお送り下さい</p>
        </div>
      </div>
    </section>
  );
}
